// Local

/* eslint-disable import/prefer-default-export */
import {
  SET_ACTIVE_GOODY,
  SET_ACTIVE_GOODIES_WITH_SHUFFLE,
  SET_SHUFFLE_GOODIES,
} from '../constants';

import { setKitten } from './activePet';
import shuffleActiveGoodiesUtil from '../utils/shuffleActiveGoodies';


// --- SET ONE ACTIVE GOODY --- //

function setActiveGoody(type, id) {
  return {
    type: SET_ACTIVE_GOODY,
    payload: {
      type,
      id,
    },
  };
}

// Set the active goodies, remove kittens and shuffle.
export function setActiveGoodyAsync(type, id, { leaveShuffleAlone } = {}) {
  return (dispatch, getState) => {
    const lastState = getState();

    // If this is a toy and there was a kitten, remove it so that the new toy is shown.
    if (lastState.activePet.active.kitten && type === 'toy') {
      dispatch(setKitten(null));
    }

    // If the new goody is different than the last one, set the new goody.
    if (lastState.activeGoodies.active[type] !== id) {
      dispatch(setActiveGoody(type, id));
    }

    // If shuffle was on, turn it off (unless leaveShuffleAlone, like from pet purchase)
    if (lastState.activeGoodies.shuffle === true && !leaveShuffleAlone) {
      dispatch(setShuffle(false));
    }
  };
}


// --- SHUFFLE ACTIVE GOODIES --- //

function setActiveGoodiesWithShuffle(activeGoodies, shuffle) {
  return {
    type: SET_ACTIVE_GOODIES_WITH_SHUFFLE,
    payload: {
      activeGoodies,
      shuffle,
    },
  };
}


// --- SHUFFLE --- //

function setShuffle(shuffle) {
  return {
    type: SET_SHUFFLE_GOODIES,
    payload: {
      shuffle,
    },
  };
}

// Find the last shuffle state, then shuffle goodies if necessary.
export function setShuffleAsync() {
  return (dispatch, getState) => {
    const lastShuffleState = getState().activeGoodies.shuffle;

    // A. Shuffle is false now.
    if (lastShuffleState === true) {
      dispatch(setShuffle(false));
      return;
    }

    // B. Shuffle is true now.
    // B1. Remove kittens.
    if (getState().activePet.active.kitten) {
      dispatch(setKitten(null));
    }
    // B2. Shuffle the goodies and set new shuffle state.
    dispatch(setActiveGoodiesWithShuffle(
      shuffleActiveGoodiesUtil(getState().collectedGoodies.list),
      true,
    ));
  };
}



// WEBPACK FOOTER //
// ./src/actions/activeGoodies.js